import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import RenderIf from '../../render-if'
import StyledContainer from './styled/index'
import StyledCheckbox from './styled/checkbox'

const InputCheckbox = forwardRef((props, ref) => {
  const {
    className,
    style,
    value,
    name,
    label,
    size = 'md',
    // 状态
    defaultChecked,
    checked,
    disabled,
    readonly,
    // 事件
    onChange,
  } = props

  return (
    <StyledContainer
      className={clsx('cursor-pointer font-size-sm', className)}
      style={style}
      ref={ref}
    >
      <StyledCheckbox
        id={`checkbox-${value}-${name}`}
        type="checkbox"
        name={name}
        className="form-checkbox dark:bg-transparent dark:checked:bg-primary-700 dark:dark-form-checkbox"
        style={style}
        value={value}
        onChange={onChange}
        disabled={disabled}
        defaultChecked={defaultChecked}
        checked={checked}
        size={size}
        readonly={readonly}
      />
      <RenderIf isTrue={label}>
        <span>{label}</span>
      </RenderIf>
    </StyledContainer>
  )
})

InputCheckbox.propTypes = {
  className: PropTypes.string,
  style: PropTypes.shape({}),
  name: PropTypes.string,
  value: PropTypes.string,
  label: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  defaultChecked: PropTypes.bool,
  disabled: PropTypes.bool,
  readonly: PropTypes.bool,
  onChange: PropTypes.func,
}
InputCheckbox.defaultProps = {
  className: undefined,
  style: {},
  name: undefined,
  value: undefined,
  label: undefined,
  size: 'md',
  defaultChecked: false,
  disabled: false,
  readonly: false,
  onChange: undefined,
}
InputCheckbox.displayName = 'InputCheckbox'

export default InputCheckbox
